const raw = process.env.VUE_APP_AMBIENTE

export const APP_ENV = String(raw ?? '')
  .replace(/['"]/g, '')
  .trim()
  .toLowerCase()

export const IS_HOMOLOG = APP_ENV === 'homolog'

export const SHOW_INTERNAL_INFO = IS_HOMOLOG
